
import { Vue, Component } from 'vue-property-decorator';
import WidgetControls from '@/features/dashboard/components/WidgetsControls.vue';

@Component({
  components: {
    WidgetControls,
  },
})
export default class Footer extends Vue {}
